export default "__VITE_ASSET__IYdfguUZ__"